import { Icon } from "@iconify/react";
import React from "react";

export default function FormButtons(props) {
  const { isLoading, handleCancel, submitProps, isRelative = false } = props;
  return (
    <div className={isRelative ? "form-buttons-container" : "floating-buttons"}>
      <button type="button" className="cancel-button" onClick={handleCancel}>
        Cancel
      </button>
      <button
        type="submit"
        className="theme-button"
        disabled={isLoading}
        {...submitProps}
      >
        {isLoading ? (
          <>
            <Icon icon="mdi:loading" className="spin" />
            Submitting...
          </>
        ) : (
          <>
            <Icon icon="mdi:send" />
            Submit
          </>
        )}
      </button>
    </div>
  );
}
